import React from 'react'

import { Navigate, Outlet } from 'react-router-dom';
const UseAuth = () =>{
 const id = localStorage.getItem('Staffid');
 if(id){
  return true;
 }else{
  return false;
 }
   
}

const StaffAuth = () => {
    const isAuth= UseAuth();
  return isAuth ? <Outlet />: <Navigate to = "/" />

}
export default StaffAuth;
